import { Link } from 'react-router-dom'
import type { Invoice } from '@/api/types'

const SHIPMENT_LABEL = 'Leverans'
const CONTRACT_LABEL = 'Avtal'
const EXTERNAL_LABEL = 'Utan leverans'

export function InvoiceReference({ invoice }: { invoice: Invoice }): React.ReactElement {
  if (invoice.shipment_id === null) {
    return <span className="text-muted-foreground">{invoice.source === 'external' ? EXTERNAL_LABEL : CONTRACT_LABEL}</span>
  }

  return (
    <Link
      to={`/shipments/${invoice.shipment_id}`}
      className="hover:underline"
    >
      {SHIPMENT_LABEL}
    </Link>
  )
}
